import { useStandardCancelFlow } from '~/hooks/useStandardCancelFlow';
import { CancellationFeedback } from './CancellationFeedback';
import { CancellationSurveyDialog } from './CancellationSurveyDialog';

// Peek, not get: the exposure was recorded when the office started the cancel.
export const CancellationFeedbackManager = () =>
  useStandardCancelFlow() ? <CancellationSurveyDialog /> : <CancellationFeedback />;
